module.exports = __webpack_public_path__ + "themes/40t/img/character.png";


//////////////////
// WEBPACK FOOTER
// ./themes/40t/img/character.png
// module id = 71
// module chunks = 3